import i18next from 'i18next';
import { parse } from 'date-fns';
import { convertUTCToLocal } from 'utils/date';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';

import s from './styles.module.scss';

import type { IBaseTableColumns } from 'components/atoms/base-table/types';
import type { NoteLog } from 'infrastructure/classes/logs/note-log';

export const notesLogsColumns = (): IBaseTableColumns<NoteLog> => {
  return [
    {
      label: i18next.t('labels.dateTime'),
      key: 'date',
      width: '130px',
      render(value) {
        const date = parse(value, 'MM-dd-yyyy | hh:mm a', new Date());
        const localDate = convertUTCToLocal(date.toString());
        let formattedDate;

        if (localDate) {
          formattedDate = DateFormatter({
            date: localDate,
            format: DateFormats['MM-dd-yyyy | h:mm a'],
          });
        }

        return (
          <span className={s.date} data-cy="logs-dateRemoved">
            {formattedDate}
          </span>
        );
      },
    },
    {
      label: i18next.t('labels.noteType'),
      key: 'type',
      width: '150px',
      responsive: ['md'],
      render(_, record) {
        return (
          <span className={s.date} data-cy="logs-type">
            {record.type}
          </span>
        );
      },
    },
    {
      label: i18next.t('labels.note'),
      key: 'note',
      width: '700px',
      responsive: ['md'],
      render(_, record) {
        return (
          <span className={s.text} data-cy="logs-note">
            {record.note}
          </span>
        );
      },
    },
    {
      label: i18next.t('labels.noteDateTime'),
      key: 'noteCreatedDate',
      width: '130px',
      render(value) {
        const date = parse(value, 'MM-dd-yyyy | hh:mm a', new Date());
        const localDate = convertUTCToLocal(date.toString());
        let formattedDate;

        if (localDate) {
          formattedDate = DateFormatter({
            date: localDate,
            format: DateFormats['MM-dd-yyyy | h:mm a'],
          });
        }

        return (
          <span className={s.date} data-cy="logs-dateRemoved">
            {formattedDate}
          </span>
        );
      },
    },
    {
      label: i18next.t('labels.deletedBy'),
      align: 'right',
      key: 'author',
      width: '130px',
      render(_, record) {
        return (
          <span className={s.who} data-cy="logs-deletedBy">
            {`${record.author} ${
              record.professionType ? `- ${record.professionType}` : ''
            }`}
          </span>
        );
      },
    },
  ];
};
